export default __webpack_public_path__ + "static/media/signup-bg.7df090bf.png";